import {Component} from 'react';
import { connect } from "react-redux";
import { Button } from 'react-bootstrap'

import translations from "../../../config/translation/login_translations.json"

const mapStateToProps = state => {
	return {	
		language: state.languageReducer ? state.languageReducer : 'ENGLISH'
	};
}

class CancelButton extends Component {
   render() {
      return (
         <Button variant="secondary" onClick={this.props.onCancel}>{translations[this.props.language].cancel}</Button>
      )
   }
}

export default connect(mapStateToProps)(CancelButton);